import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

import LandingPage from './pages/user/LandingPage';
import ConsentPage from './pages/user/ConsentPage';
import RegistrationPage from './pages/user/RegistrationPage';
import Login from './pages/auth/Login';
import './index.css';
import Dashboard from './pages/adminpages/Dashboard';
import Reports from './pages/adminpages/Reports';
import RegisterAdmin from './pages/adminpages/RegisterAdmin';
import Analytics from './pages/analytics/Analytics';
import ResponsePage from './components/Responses';
import ChatWidgetWrapper from './components/ChatWidgetWrapper';
import { AgriChatbot } from './components/AgriChat';
import RegistrationDone from './components/RegistrationDone';
import Settings from './pages/adminpages/Settings';
import { AuthProvider } from './context/AuthContext';
import ProtectedRoute from './components/ProtectedRoute';

function App() {
  return (
    <AuthProvider>
      <Router>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/consent" element={<ConsentPage />} />
          <Route path="/registration" element={<RegistrationPage />} />
          <Route path="/login" element={<Login />} />
          <Route path="/chat" element={<AgriChatbot />} />
          <Route path="/done" element={<RegistrationDone />} />

          
          <Route path="/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
          <Route path="/analytics" element={<ProtectedRoute><Analytics /></ProtectedRoute>} />
          <Route path="/responses" element={<ProtectedRoute><ResponsePage /></ProtectedRoute>} />
          <Route path="/reports" element={<ProtectedRoute><Reports /></ProtectedRoute>} />
          <Route path="/settings" element={<ProtectedRoute><Settings /></ProtectedRoute>} />
          <Route path="/register-admin" element={<ProtectedRoute><RegisterAdmin /></ProtectedRoute>} />
        </Routes>
        <ChatWidgetWrapper />
      </Router>
    </AuthProvider>
  );
}

export default App;